import styled from 'styled-components/macro';
import * as colors from '../colorConstants';
import { ThreeBounce as Spinner } from 'better-react-spinkit';

export const SpinnerWrapper = styled(Spinner)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 19;
  width: 100%;
`;

export const SpinnerBackground = styled.div`
  height: 100vh;
  width: 100vw;
  position: absolute;
  z-index: 19;
  top: 0;
  left: 0;
  background: ${colors.blackTransparent};
`;
